const DEFAULT_DISPLAY = {
  showEstimatedDeliveryDate: true,
  showPromiseDateTime: false,
  showScheduledSlot: true,
  showScheduleType: true,
  showAsapExpectedTime: false,
};

export const resolveOrderDeliveryDisplay = (order = {}, brandEntry = null) => {
  const ordersDisplay =
    brandEntry?.deliveryProfile?.ordersDisplay ||
    brandEntry?.resolvedProfile?.ordersDisplay ||
    null;

  if (ordersDisplay) {
    return {
      ...DEFAULT_DISPLAY,
      ...ordersDisplay,
    };
  }

  const scheduleType = String(order.scheduleType || "").toLowerCase();
  const isSalasa =
    String(order.serviceProvider || order.brandIntegration || "")
      .trim()
      .toLowerCase() === "salasa";

  if (scheduleType === "immediate") {
    return {
      ...DEFAULT_DISPLAY,
      showEstimatedDeliveryDate: false,
      showScheduledSlot: false,
      showAsapExpectedTime: true,
    };
  }

  if (isSalasa) {
    return {
      ...DEFAULT_DISPLAY,
      showEstimatedDeliveryDate: false,
      showPromiseDateTime: true,
      showScheduledSlot: false,
    };
  }

  return { ...DEFAULT_DISPLAY };
};

export const resolveOrderDeliveryDate = (order = {}) => {
  if (String(order.orderType || "").toLowerCase() !== "delivery") {
    return null
  }

  if (order.estimatedDeliveryDate) {
    return order.estimatedDeliveryDate
  }

  if (order.pickupDate && String(order.scheduleType || "").toLowerCase() === "scheduled") {
    const datePart = new Date(order.pickupDate)
    if (!Number.isNaN(datePart.getTime())) {
      const slotStart = String(order.pickupTime || "")
        .split("–")[0]
        .trim()
      if (slotStart) {
        const [hours, minutes] = slotStart.split(":").map(Number)
        if (!Number.isNaN(hours)) {
          datePart.setHours(hours, Number(minutes) || 0, 0, 0)
        }
      }
      return datePart.toISOString()
    }
  }

  if (order.promiseDateTime) {
    return order.promiseDateTime
  }

  return null
}

export const findAssignedBrandForOrder = (order = {}, assignedBrands = []) => {
  const brandId = String(order?.brandId?._id || order?.brandId || "").trim();
  if (!brandId) {
    return null;
  }
  return (
    (assignedBrands || []).find(entry => String(entry.brandId) === brandId) ||
    null
  );
};
